import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { SecondaryItem } from "../../../../http/deckDesigner/types/secondaryItems";
import useDeckSecondaryItemsApi from "../../../../http/deckDesigner/useSecondaryItems";
import SecondaryItemForm from "./SecondaryItemForm";

const AdminSecondaryItems: FC = () => {
  const i18n = useI18n();
  const secondaryItemsApi = useDeckSecondaryItemsApi();

  return (
    <AdminCrudTable<SecondaryItem>
      filterPrefix="secondary_items"
      useList={secondaryItemsApi.useDeckSecondaryItems}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.thickness}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.length}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item.code}</TableCell>
          <TableCell>{item.item.description}</TableCell>
          <TableCell>
            {item.thickness} {i18n.translation.common.unitMm}
          </TableCell>
          <TableCell>
            {item.length} {i18n.translation.common.unitMm}
          </TableCell>
        </>
      )}
      renderForm={(item, onClose) => <SecondaryItemForm secondaryItem={item} onClose={onClose} />}
    />
  );
};

export default AdminSecondaryItems;
